import React from 'react';
import 'twin.macro';
import { useBillingInfos } from '@teetsh/app/src/queries/useBillingInfos';
import { useGlobalMessage } from '@teetsh/app/src/queries/globalMessage/useGlobalMessage';
import { SubHeaderExpiringAbo } from './SubHeaderExpiringAbo';
import { ConfirmEmailHeader } from './ConfirmEmailHeader';
import { NewSchoolyearHeader } from './NewSchoolyearHeader';
import { GlobalMessageBanner } from '../GlobalMessage/GlobalMessageBanner';
import { useTranslation } from 'react-i18next';

export default function SubHeaderDataLoader() {
  const { i18n } = useTranslation();
  const { isLoading, data: billingInfos } = useBillingInfos();
  const globalMessage = useGlobalMessage(i18n.language, {
    userPlan: billingInfos?.plan,
  });

  if (isLoading || !billingInfos) {
    return null;
  }
  return (
    <>
      <GlobalMessageBanner globalMessage={globalMessage} />
      <SubHeaderExpiringAbo
        isPastDue={billingInfos.subscriptionStatus === 'past_due'}
        remainingDays={billingInfos.remainingDaysBeforeExpiration}
        plan={billingInfos.currentPlanLabel}
      />
      <ConfirmEmailHeader />
      <NewSchoolyearHeader />
    </>
  );
}
